const MAX_DESKTOP_LABEL_CHARS = 12;
const DESKTOP_LABEL_SUFFIX_CHARS = 2;

interface DesktopIconLabelProps {
  text: string;
}

export function DesktopIconLabel({ text }: DesktopIconLabelProps) {
  return <span className="os-icon-label">{middleEllipsize(text)}</span>;
}

function middleEllipsize(text: string): string {
  const chars = Array.from(text);
  if (chars.length <= MAX_DESKTOP_LABEL_CHARS) return text;

  const prefixLength = MAX_DESKTOP_LABEL_CHARS - DESKTOP_LABEL_SUFFIX_CHARS - 1;
  return `${chars.slice(0, prefixLength).join('')}…${chars.slice(-DESKTOP_LABEL_SUFFIX_CHARS).join('')}`;
}
